import script from "./SearchDialogheader.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDialogheader.vue?vue&type=script&setup=true&lang=js"

import "./SearchDialogheader.vue?vue&type=style&index=0&id=3b88d054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b88d054"]])

export default __exports__